import { Outlet } from 'react-router-dom';
import AblyAuth from '@/routes/AblyAuth';
import RequireNS from '@/routes/RequireNS';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { WebinarLanguageProvider } from '@/contexts/WebinarLanguageContext';

export default function PublicLiveLayout() {
  return (
    <WebinarLanguageProvider>
      <RequireNS ns={['auth', 'common', 'webinars']}>
        <AblyAuth>
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </AblyAuth>
      </RequireNS>
    </WebinarLanguageProvider>
  );
}
